import React from "react";

const CoachNameConfigModal = ({ protocol, handleProtocolChange, onClose }) => {
  if (!protocol) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-xl w-96 max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-4">Configure Coach Name</h2>
        <div className="mb-4">
          <label
            htmlFor="coach-name-input"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Coach Name
          </label>
          <input
            id="coach-name-input"
            type="text"
            value={protocol.coach_name || ""}
            onChange={(e) => handleProtocolChange("coach_name", e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter coach name..."
          />
          <p className="text-xs text-gray-500 mt-1">
            This name will be used in prompts like {"{coach_name}"}.
          </p>
        </div>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
          >
            Close
          </button>
          {/* No Save button needed as changes are debounced via handleProtocolChange */}
        </div>
      </div>
    </div>
  );
};

export default CoachNameConfigModal;
